import { JSONApiRelation, JSONApiResourceBase } from '../interfaces/JSONApi.js'

export enum CampaignTypes {
  SmartPredictive = 'SmartPredictive',
  Predictive = 'Predictive',
  Presented = 'Presented',
  PresentedPush = 'PresentedPush',
}

export enum CampaignListStatus {
  UNKNOWN = 'UNKNOWN',
  LOADING = 'LOADING',
  READY = 'READY',
  DIALING = 'DIALING',
  LOW_LEADS = 'LOW_ON_LEADS',
  VERY_LOW_LEADS = 'VERY_LOW_ON_LEADS',
  OUT_OF_LEADS = 'OUT_OF_LEADS',
  ENRICHING = 'ENRICHING',
  LOW_CREDITS = 'LOW_CREDITS',
  DIALING_VMD_PAUSED = 'DIALING_VMD_PAUSED',
  RECYCLING = 'RECYCLING',
  RECYCLING_LOW = 'RECYCLING_LOW',
  RECYCLING_NO_DIALABLE_LEADS = 'RECYCLING_NO_DIALABLE_LEADS',
}


export interface UploadFileResponse extends JSONApiResourceBase {
  type: 'upload'
  attributes: {
    headers: Array<string>
  }
}

export interface FieldMapDetail {
  field: string
  type?: string
  order?: number
}

export interface FieldMapping {
  [key: string]: string | FieldMapDetail
}

export interface CampaignListConfig {
  doNotDialKnownNoContacts?: boolean
  estimatedContactRatio?: number
  estimatedContactRatioUnknowns?: number
}

export interface CampaignList extends JSONApiResourceBase {
  type: 'campaignLists'
  attributes: {
    name?: string
    fileUploaded?: string
    diallerActive?: boolean
    diallerType?: CampaignTypes
    status?: CampaignListStatus
    additionalConfig?: CampaignListConfig
    createdAt?: string
    updatedAt?: string
    statusChangedAt?: string
  }
  meta?: {
    totalRecords: number
    totalNumbers: number
    recordsDialled: number
    numbersDialled: number
  }
  relationships: {
    campaign: JSONApiRelation
    queue: JSONApiRelation
  }
}

export interface RecordSortOrder {
  field: string
  direction: string
}

export interface RecordStatusData {
  available: {
    available_count: string
  }
  statuses: Array<{
    last_outcome: string
    dialled_times: number
    record_count: string
  }>
}

export interface RecordStatus {
  meta: RecordStatusData
}
